var React = require('react');

function Astrahus (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Astrahus"),React.createElement("g",{"id":"g1466","key":2},[React.createElement("path",{"id":"path1618-3-5-6-3","className":"cls-1","d":"M114,59H14v50H114Z","key":0}),React.createElement("path",{"id":"path1652-6-9-9-7","className":"cls-1","d":"M64,49V19","key":1})])]);
}

Astrahus.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Astrahus;

Astrahus.default = Astrahus;
